
 <div id="profile-pic-demo" class="bg-light pt-3">
  <VueFileAgent
     ref="profile"
     class="profile-pic-upload-block"
    :multiple="false"
    :deletable="false"
    :meta="false"
    :compact="true"
    :accept="'image/*'"
    :maxSize="'400MB'"
    :maxFiles="1"
    :helpText="selectText"
    :errorText="{
      type: errorMessage,
      size: errorSize,
     }"
     v-model="fileRecords"
     @select="filesSelected($event)"
  >

  <template v-slot:after-inner>
      <!-- <span title="after-inner" class="">프로필 이미지를 넣어 주세요.</span> -->

      <div>
          <button type="button" class="btn"  v-show="fileRecords" @click="removePic()">삭제</button>
      </div>
   </template>

  </VueFileAgent>
</div>
